import { IStateSpuTCM } from 'src/entity/StateEntity';
import { SPU_TCM_STATUS_RELOAD, SPU_TCM_STATUS_SUCCESS, SPU_TCM_STATUS_REQUEST, SPU_TCM_STATUS_FAILURE } from 'src/constants/ActionTypes';

const initialState: IStateSpuTCM = {
  reload: true,
  isFetching: false,
  type: SPU_TCM_STATUS_RELOAD,
  tcmList: [],
};

export const spuTcmState = (state: IStateSpuTCM = initialState, action: IStateSpuTCM): IStateSpuTCM => {
  switch (action.type) {
    case SPU_TCM_STATUS_SUCCESS:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        tcmList: action.tcmList,
      });

    case SPU_TCM_STATUS_REQUEST:
      return Object.assign({}, state, {
        reload: false,
        isFetching: true,
        type: action.type,
        tcmList: [],
      });

    case SPU_TCM_STATUS_RELOAD:
      return Object.assign({}, state, {
        reload: true,
        isFetching: false,
        type: action.type,
        tcmList: [],
      });

    case SPU_TCM_STATUS_FAILURE:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        tcmList: [],
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/spuTcmState.ts